export const environment = {
  production: true,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  // url:{
  //   BASE_URL: 'https://fleetconsent-api.cerebrumx.ai/v1/',
  //   authUrl: 'https://fleetconsent-api.cerebrumx.ai/v1/cms/',
  // }

  url: {
    BASE_URL: 'https://denali.cerebrumx.ai/a1/api/v1/cms/',
    authUrl: 'https://denali.cerebrumx.ai/a1/api/v1/',
  },
};

